module.exports = __webpack_public_path__ + "static/media/alternative-light.13c2e051.svg";